const newsletter = `
# eBL Newsletter 2

## 5 February 2021

### Fragmentarium

#### Folios

- The folios of Andrew R. George are now part of the Fragmentarium (957 tablets,
  319 folios). They were catalogued by Luis Sáenz and Ekaterine Gogokhia and
  digitised and entered by Junko Taniguchi.
- The folios of George Smith will be added in the near future.

#### Yale Babylonian Collection

- The database of the YBC is now integrated into the fragmentarium (almost
  40,000 data sets, 400 photos by Klaus Wagensonner). The catalogue was kindly
  provided by Agnete Lassen.
- See [MLC.1874](https://www.ebl.lmu.de/fragmentarium/MLC.1874) as an example.

#### File Export

- Fragmentarium editions can now be exported as word-files in addition to the
  option to export an ATF, JSON, or TEI-file. PDF-export will be available in
  the near future. The export function was developed by David Englmeier.

### Corpus

#### Conventions

- The 
  [Conventions for eBL-Corpus Editions](https://github.com/ElectronicBabylonianLiterature/generic-documentation/wiki/Editorial-conventions-(Corpus))
  have been thoroughly revised, updated, and restructured. The biggest update 
  pertains to the general structure of the underlying representational model. 
  The model is now clearly defined and should be applicable to corpora other 
  than SB Literature. See also the guide „Structure a Corpus“ under 2.1. 
  Please get back to us if the guide falls short in answering your questions.
- Smaller additions were made under
  - 2.7.4 Parallel Lines (addition of corpus siglum L for Literature and F for
    fragments)
  - 2.5.4 Special Cases (normalize _ānu_ instead of _anu_)`

export default newsletter
